export default {"src":"/pro/_next/static/media/brett.21515bfb.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};